module.exports = __webpack_public_path__ + "static/img/secondVisit.481289b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/secondVisit.png
// module id = 6uqt
// module chunks = 1